const MutedButtonOn = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={14}
        height={11}
        fill="none"
        viewBox="0 0 14 11"
    >
        <path d="M12.75 3.32143L9.15 7.17857M9.15 3.32143L12.75 7.17857M6.15 0.75L3.15 3.32143H0.75V7.17857H3.15L6.15 9.75V0.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)
export default MutedButtonOn
